import { get, patch, post, remove } from 'vio-libs';
export function getEdgeEventsAlerts(organization) {
    return get(`edge-events-rules?organization=${organization}&type=alerts`);
}
export function getEdgeEventsRules(organization) {
    return get(`edge-events-rules?organization=${organization}&type=preset`);
}
export function getEdgeEventsSites(organization) {
    return get(`edge-events-sites?organization=${organization}`);
}
export function postEdgeEventsAlert(organization, alert) {
    return post(`edge-events-rules?organization=${organization}`, {
        data: Object.assign({}, alert)
    });
}
export function patchEdgeEventsAlert(organization, alert) {
    return patch(`edge-events-rules?organization=${organization}`, {
        data: Object.assign({}, alert)
    });
}
export function removeEdgeEventsAlert(organization, alert) {
    return remove(`edge-events-rules?organization=${organization}`, {
        data: Object.assign({}, alert)
    });
}
